import { Component, signal, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/auth/services/auth.service';
import { FingerprintCardValidityStatus } from 'src/shared/constants';
import { ProfileClient } from 'src/shared/services/api.service';
import { ConfigService } from 'src/shared/services/config.service';
import { FeatureManagementService } from 'src/shared/services/feature-management.service';
import { TourService } from 'src/shared/services/tour.service';
import { edPortalTerms } from 'src/shared/term-explanations';

@Component({
  standalone: false,
  selector: 'edportal-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;
  ein = signal('');
  educatorName = signal('');

  einExplanation: string = edPortalTerms.ein;
  fingerprintValidityExplanation: string = edPortalTerms.fingerprintValidity;
  fingerprintValidityStatus = signal('');
  fingerprintCardValidityStatus = FingerprintCardValidityStatus;
  environment?: string;

  complexProfessionalDevelopmentEnabled = signal(false);

  toursEnabled = signal(false);

  routesWithTour: Record<string, string> = {
    home: 'homeTour',
    'application/todos': 'todosTour',
    'application/summary': 'summaryTour',
  };

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly profileClient: ProfileClient,
    private readonly configService: ConfigService,
    private readonly tourService: TourService,
    private readonly featureManager: FeatureManagementService,
  ) {
    this.environment = this.configService.config.environment;
  }

  ngOnInit() {
    this.profileClient.getEducatorProfileInfo().subscribe((x) => {
      this.ein.set(x.ein!);
      this.educatorName.set(x.name!);
      this.fingerprintValidityStatus.set(x.fingerprintCardValidityStatus!);
    });

    this.featureManager.features.subscribe((features) => {
      this.toursEnabled.set(features.edPortalTour);
      this.complexProfessionalDevelopmentEnabled.set(features.complexProfessionalDevelopment);
    });
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  logout(event: Event): void {
    event.preventDefault();

    this.authService.logout();
  }

  stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
  }

  getMatchingRoute(): string | null {
    const currentRoute = this.router.url;

    for (const route in this.routesWithTour) {
      if (currentRoute.includes(route)) {
        return route;
      }
    }
    return null;
  }

  isRouteWithTour(): boolean {
    const matchingRoute = this.getMatchingRoute();

    return matchingRoute != null;
  }

  showTourForCurrentRoute() {
    const matchingRoute = this.getMatchingRoute();

    if (matchingRoute) {
      const tourName = this.routesWithTour[matchingRoute];
      switch (tourName) {
        case 'homeTour':
          this.tourService.startHomeTour();
          break;
        case 'todosTour':
          this.tourService.startToDoTour();
          break;
        case 'summaryTour':
          this.tourService.startApplicationSummaryTour();
          break;
        default:
          break;
      }
    } else {
      console.log('No matching route for tour found.');
    }
  }
}
